/**
 * Storage for form fields that need to be available on other pages. E.g. email and application_cohort_name selected on Apply P2
 * are used on later pages for assessment generation. Moving them through URL is both unsafe and inconvenient.
 *
 * Once initialized with formElement, it will automatically keep (overwriting earlier values) fields that has `storeField` or `data-storage-field`
 * input attributes.
 *
 * NOTE: currently it works for text inputs, selects and other inputs that provide .value. If needed, add radio/checkbox support.
 *
 * It's localStorage based.
 *
 * @param formElement
 * @returns {formFieldsStorage}
 */

import {getInputValue} from "./forms";

export const formFieldsStorage = function (formElement) {
  const self = this

  /**
   * Store field
   * @param name
   * @param value if null field will be deleted from storage
   */
  self.storeField = function (name, value) {
    let storageData = window.localStorage.getObject('formStorageData')
    if (!storageData) {
      storageData = {}
    }
    if (value !== null) {
      storageData[name] = value
    } else {
      delete storageData[name]
    }
    window.localStorage.setObject('formStorageData', storageData)
  }

  self.deleteField = function (name) {
    self.storeField(name, null)
  }

  self.handleFormFieldChange = function (field) {
    const value = getInputValue(field)
    if (value) {
      self.storeField(field.name, value)
    }
  }

  /**
   * Get stored field value or null
   *
   * @param name
   */
  self.getField = function (name) {
    const storageData = window.localStorage.getObject('formStorageData')
    if (storageData) {
      return storageData[name] || null
    }
    return null
  }

  self.getAllFields = function () {
    return window.localStorage.getObject('formStorageData') || {}
  }

  self.watchFieldsToStore = function (fieldsToStore) {
    fieldsToStore.forEach(field => {
      // use the pre-set values if set
      self.handleFormFieldChange(field)

      field.addEventListener('change', function (event) {
        self.handleFormFieldChange(event.target)
      })
    })
  }

  if (formElement) {
    const fieldsToStore = formElement.querySelectorAll('[data-store-field], [storefield], [storeField]')
    self.watchFieldsToStore(fieldsToStore)
  }

  return self
}